const resolvedApiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

if (process.env.NODE_ENV === 'production' && !resolvedApiUrl.startsWith('https://')) {
    throw new Error('API_URL must use HTTPS in production');
}

const Config = {
    API_URL: resolvedApiUrl,
    projectRegion: process.env.REACT_APP_AWS_PROJECT_REGION || '',
    cognitoRegion: process.env.REACT_APP_AWS_COGNITO_REGION || '',
    userPoolsId: process.env.REACT_APP_AWS_USER_POOLS_ID || '',
    userPoolsWebClientId: process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID || '',
}

export const {
    API_URL,
    projectRegion,
    cognitoRegion,
    userPoolsId,
    userPoolsWebClientId
} = Config;

export type AppEnvironment = "production" | "staging" | "development" | "unknown";

function normalizeEnv(value: unknown): string {
    return String(value ?? "").trim().toLowerCase();
}

export function getAppEnvironment(): AppEnvironment {
    const raw = normalizeEnv(process.env.REACT_APP_ENV);
    if (raw === "production" || raw === "prod") return "production";
    if (raw === "staging" || raw === "stage" || raw === "stg") return "staging";
    if (raw === "development" || raw === "dev") return "development";
    return raw ? "unknown" : "development";
}

// TOTP "issuer" shown as the large heading in authenticator apps after scanning.
export function getTotpIssuerTitle(): string {
    const env = getAppEnvironment();
    switch (env) {
        case "staging":
            return "BuildCompliance-Staging";
        case "production":
            return "BuildCompliance-Production";
        case "development":
            return "BuildCompliance-Development";
        default:
            return "BuildCompliance";
    }
}
